// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryPreviewItem__container-da6457 {
  cursor: pointer;
  position: relative;
  height: 100%;
}

.MediaGalleryPreviewItem__container-da6457.MediaGalleryPreviewItem__selected-d38a0c {
  cursor: default;
}

.MediaGalleryPreviewItem__overlay-d777d4 {
  background-color: var(--addition-40_70);
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}

.MediaGalleryPreviewItem__container-da6457:hover .MediaGalleryPreviewItem__overlay-d777d4,
.MediaGalleryPreviewItem__container-da6457.MediaGalleryPreviewItem__selected-d38a0c .MediaGalleryPreviewItem__overlay-d777d4 {
  display: none;
}

.MediaGalleryPreviewItem__image-f4ff57 {
  border-radius: 4px;
  object-fit: cover;
  height: 100%;
  max-width: 112px;
  min-width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryFooter/MediaGalleryPreviewItem/MediaGalleryPreviewItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;;EAEE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  cursor: pointer;\n  position: relative;\n  height: 100%;\n}\n\n.container.selected {\n  cursor: default;\n}\n\n.overlay {\n  background-color: var(--addition-40_70);\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.container:hover .overlay,\n.container.selected .overlay {\n  display: none;\n}\n\n.image {\n  border-radius: 4px;\n  object-fit: cover;\n  height: 100%;\n  max-width: 112px;\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryPreviewItem__container-da6457`,
	"selected": `MediaGalleryPreviewItem__selected-d38a0c`,
	"overlay": `MediaGalleryPreviewItem__overlay-d777d4`,
	"image": `MediaGalleryPreviewItem__image-f4ff57`
};
module.exports = ___CSS_LOADER_EXPORT___;
